import {
  connectToRemote as connectToWebviewRemote,
  Remote as WebviewRemote,
} from 'react-native-webview-messaging/dist/web'

export type { WebviewRemote }

export const connectToRemote = () => connectToWebviewRemote()
